/**
 * Checks if a text string looks like a URL (starts with http:// or https://).
 */
export const isUrlLike = (text: string): boolean => {
	return /^https?:\/\//.test(text.trim());
};
